<template>
  <div class="course-introduction-dialog">
    <el-dialog title="课程介绍" :visible.sync="visible" width="60%" :close-on-click-modal="false" :before-close="handleClose">
      <p v-if="content" v-html="content"></p>
      <embed v-if="courseFile" :src="courseFile" type="application/pdf" width="100%" height="400px" />
    </el-dialog>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  content: {
    type: String,
    default: ''
  },
  courseFile: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['handleClose'])

const visible = computed(() => props.visible)

const handleClose = () => {
  emit('update:visible', false)
}
</script>

<style scoped lang="scss">
:deep(.el-dialog__header) {
  border-bottom: 1px solid rgba($color: #000000, $alpha: 0.09);
}

p {
  margin: 0;
  padding: 0;
  color: #666666;
  font-size: 14px;
  margin-bottom: 15px;
}
</style>
